import React from "react";

const LatestActivities = () => {
  const activities = [
    {
      title:
        "Join the Tillionx Discord AMA to Learn More About BNB & Win Rewards",
      date: "2025-08-21",
    },
    {
      title:
        "Learn & Earn: Complete the Quiz to Share 850,000 KernelDAO (KERNEL) Token Rewards!",
      date: "2025-08-21",
    },
    {
      title:
        "Tillionx Square: Complete Tasks in the CreatorPad to Unlock $100,000 in Kava (KAVA) Token Rewards!",
      date: "2025-08-21",
    },
    {
      title:
        "MENA and South Asian Exclusive: Hot Summer, Hotter Prizes! Buy or Sell Crypto to Win Up to 300 USDT",
      date: "2025-08-21",
    },
    {
      title:
        "Tillionx Earn New Listing Special Offer: Subscribe to PLUME Locked Products to Enjoy 200% APR for 7 Days!",
      date: "2025-08-21",
    },
    {
      title:
        "BNB Cryptoback Extended: Keep Earning BNB and Share a $150,000 Prize Pool",
      date: "2025-08-21",
    },
  ];

  return (
    <div>
      <div className="rounded-lg shadow-sm p-6 border border-gray-200 max-w-7xl mx-auto font-sans my-16">
         <nav className="flex items-center text-sm  mb-6">
          <span className="">Announcement</span>
          <span className="mx-2">›</span>
          <span className="font-semibold text-xs">Latest Activities</span>
        </nav>
        {/* Header */}
        <h2 className="text-xl font-bold mb-6">
          Latest Activities
        </h2>

        {/* Activities List */}
        {activities.map((item, index) => (
          <div
            key={index}
            className="py-4 border-b border-gray-200 last:border-b-0"
          >
            <h3 className="text-base font-medium leading-snug hover:underline cursor-pointer">
              {item.title}
            </h3>
            <p className="text-sm mt-1">{item.date}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LatestActivities;
